export const SupportedAndroidVersions = [7, 8, 9, 10];
export const SupportedIOSVersions = [10, 11, 12, 13, 14];
